import { NgComponentOutlet } from '@angular/common';
import { Component, OnInit } from '@angular/core';


import { ConfigService } from '../../core/service/config/config.service';
import { LoginGCOlivaComponent } from './gcoliva/login.gcoliva.component';
import { LoginGisecloudComponent } from './gisecloud/login.gisecloud.component';
import { LoginSolpolComponent } from './solpol/login.solpol.component';
import { LoginStluciaComponent } from './stlucia/login.stlucia.component';




@Component({
  selector: 'app-login',
  standalone: true,
  imports: [NgComponentOutlet],
  template: `<ng-container *ngComponentOutlet="loginComponent"></ng-container>`,
})
export class LoginComponent implements OnInit {
  loginComponent: any;

  constructor(private configService: ConfigService) { }

  ngOnInit(): void {
    const template = this.configService.get('template') || 'gisecloud';
    switch (template) {
      case 'adpol':
        this.loginComponent = LoginStluciaComponent;
        break;
      case 'solpol':
        this.loginComponent = LoginSolpolComponent;
        break;
      case 'gisecloud':
        this.loginComponent = LoginGisecloudComponent;
        break;
      case 'gcoliva':
        this.loginComponent = LoginGCOlivaComponent;
        break;
      default:
        this.loginComponent = LoginGisecloudComponent;
    }
  }
}